import { updateUserSettings as _updateUserSettings } from '@griply/services';
import { UserSettings } from '@griply/types';
import { serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getUser } from './get-user';
import { doc, getDatabase } from './helpers';

export const updateUserSettings = async (
  userSettings: Partial<UserSettings>,
): Promise<void> => {
  const user = await getUser();
  if (!user) {
    return;
  }

  const uid = user.uid;
  const db = getDatabase();

  await _updateUserSettings({
    userSettings,
    userId: uid,
    doc,
    updateDoc,
    db,
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateUserSettings,
        error,
        uid,
        docPath: `users/${uid}`,
      }),
  });
};
